var _path, _path2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H65C68 10 70 12 70 15V40C70 43 68 45 65 45H40L30 55V45H20C17 45 15 43 15 40V15C15 12 17 10 20 10Z",
    stroke: "#d946ef",
    strokeWidth: 3,
    fill: "none",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5H55C58 5 60 7 60 10V30C60 33 58 35 55 35H25L15 45V35H10C7 35 5 33 5 30V10C5 7 7 5 10 5Z",
    stroke: "#d946ef",
    strokeWidth: 3,
    fill: "none",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 20,
    r: 2.5,
    fill: "#d946ef"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 20,
    r: 2.5,
    fill: "#d946ef"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 20,
    r: 2.5,
    fill: "#d946ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/chaticon.85391cb1bc6a9722043c0c9cfedf8a36.svg";
export { ForwardRef as ReactComponent };